import { useState, useEffect } from 'react';
import qualifySound from '@/assets/qualify.mp3';
import { useRegistrationFlow } from './use-registration-flow';

const PHASE_DELAY_MS = 5500;
const SOUND_LAG_MS = 250;

function playQualifySound(): void {
  const audio = new Audio(qualifySound);
  audio.volume = 0.6;
  void audio.play().catch(() => undefined);
}

export function useResultReveal(passed: boolean): boolean {
  const [loading, setLoading] = useState(true);
  const { setResultPassed } = useRegistrationFlow();

  useEffect(() => {
    const id = setTimeout(() => setLoading(false), PHASE_DELAY_MS);
    return () => clearTimeout(id);
  }, []);

  useEffect(() => {
    if (!passed) return;
    const id = setTimeout(playQualifySound, PHASE_DELAY_MS - SOUND_LAG_MS);
    return () => clearTimeout(id);
  }, [passed]);

  useEffect(() => {
    if (!loading && passed) setResultPassed();
  }, [loading, passed, setResultPassed]);

  return loading;
}
